import { api } from "../Configurations/axios";

const GetAllNewsAPI = async (page: number, take: number, word: string) => {
    try {
        var result = await api.get(`/News/GetAllNews/?page=${page}&take=${take}&word=${encodeURIComponent(word)}`);
        var response = result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

const GetAllNewsToHome = async () => {
    try {
        var result = await api.get('/News/GetAllNewsToHome/');
        var response = result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

const GetNewsAPI = async (newsId: string) => {
    try {
        var result = await api.get(`/News/GetNews/?id=${newsId}`);
        var response = result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

const CreateNewsAPI = async (file: any, title: string, externLink: string, userEmail: string) => {
    try {
        var CreateNewsCommand = new FormData();

        CreateNewsCommand.append("ImageFile", file[0]);

        const result = await api.post(`/News/CreateNews/?title=${encodeURIComponent(title)}&userEmail=${encodeURIComponent(userEmail)}&externLink=${externLink}`, CreateNewsCommand, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const EditNewsAPI = async (newsId: string, title: string, externLink: string, userEmail: string) => {
    try {
        const result = await api.put("/News/EditNews", { id: newsId, title: title, externLink: externLink, userEmail: userEmail });
        const response = result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

const DeleteNewsAPI = async (id: string) => {
    try {
        const result = await api.delete('/News/DeleteNews', { data: { id: id } });
        const response = result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

export {
    GetAllNewsAPI,
    GetAllNewsToHome,
    GetNewsAPI,
    CreateNewsAPI,
    EditNewsAPI,
    DeleteNewsAPI
}